module.exports = __webpack_public_path__ + "img/22.b5417c91.png";